import { MoreVertOutlined } from "@mui/icons-material";
import { Box, Card, IconButton, Typography } from "@mui/material";
import React from "react";
import DriversStyles from "../DriversStyles";
import { IPolicyDriver } from "../../../../../../models/user/policyDetails/PolicyDetails";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface IProps {
  drivers: IPolicyDriver[];
  handleMoreClick?: (event: any, driver: any) => void;
  displayMoreOptions: boolean;
}
const DriversMobileView: React.FC<IProps> = ({
  drivers,
  handleMoreClick,
  displayMoreOptions,
}) => {
  const { lobCode } = useParams();

  const { t } = useTranslation();
  return (
    <Box sx={{ display: "grid", gap: "20px" }}>
      {drivers.length > 0 ? (
        drivers.map((driver: IPolicyDriver, index: number) => (
          <Card key={`dri-${index}`} sx={DriversStyles.mobileCard}>
            <Box sx={DriversStyles.driverName}>
              <Typography sx={DriversStyles.name}>{`${driver.givenName} ${
                driver.surName || ""
              }`}</Typography>
              <Typography sx={DriversStyles.gender}>
                {driver.genderCd} | {driver.driverAge}
              </Typography>
            </Box>
            <Typography sx={DriversStyles.drivingLicense}>
              {driver.licensedStateProvCd}-{driver.licenseNumber}
            </Typography>
            {lobCode && lobCode !== "PU" ? (
              <Box>
                <Box sx={DriversStyles.type}>
                  {t("Type")}:&nbsp;
                  <Typography sx={DriversStyles.vehicleType}>
                    {driver.typeOfDriver ? driver.typeOfDriver : "-"}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <></>
            )}
            <Box>
              <Box sx={DriversStyles.type}>
                {t("Marital Status")}:&nbsp;
                <Typography sx={DriversStyles.vehicleType}>
                  {driver.maritalStatus ? driver.maritalStatus : "-"}
                </Typography>
              </Box>
            </Box>
            {displayMoreOptions && (
              <IconButton
                sx={{ position: "absolute", right: "0px" }}
                onClick={(event) =>
                  handleMoreClick && handleMoreClick(event, driver)
                }
              >
                <MoreVertOutlined />
              </IconButton>
            )}
          </Card>
        ))
      ) : (
        <Card sx={DriversStyles.noDriversCard}>
          <Typography sx={DriversStyles.noDriversText}>
            {t("No Drivers Found")}
          </Typography>
        </Card>
      )}
    </Box>
  );
};

export default DriversMobileView;
